// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__xoifN","lessonImg":"styles_lessonImg__gj25h","discription":"styles_discription__LoYnn"};